/**
 * Sprint 23.7 — small shared bits for the `/welcome` step bodies: the "Step N of
 * 3" kicker, the step heading, and the primary action button. Keeping these in
 * one place stops the three steps from drifting.
 */

import { type CSSProperties, type ReactNode } from "react";

export function StepLabel({ children }: { children: ReactNode }) {
  return <span style={stepLabelStyle}>{children}</span>;
}

export function StepHeading({ children }: { children: ReactNode }) {
  return <h3 style={headingStyle}>{children}</h3>;
}

/** Flex spacer that pushes the footer to the bottom of the card body. */
export function StepSpacer() {
  return <div style={{ flex: 1 }} />;
}

export function PrimaryButton({
  onClick,
  disabled,
  children,
  withArrow = true,
}: {
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode;
  withArrow?: boolean;
}) {
  return (
    <button type="button" onClick={onClick} disabled={disabled} style={{ ...primaryButtonStyle, opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer" }}>
      {children}
      {withArrow && <i className="ti ti-arrow-right" style={{ fontSize: 14 }} aria-hidden="true" />}
    </button>
  );
}

const stepLabelStyle: CSSProperties = {
  fontSize: 11,
  color: "var(--color-text-tertiary)",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
};

const headingStyle: CSSProperties = {
  fontSize: 22,
  fontWeight: 500,
  lineHeight: 1.3,
  margin: "4px 0 0",
  color: "var(--color-text-primary)",
};

const primaryButtonStyle: CSSProperties = {
  padding: "10px 18px",
  fontSize: 13,
  fontWeight: 500,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 6,
  background: "var(--color-text-primary)",
  color: "var(--color-background-primary)",
  border: "none",
  borderRadius: "var(--border-radius-md)",
  fontFamily: "var(--font-sans)",
};
